module.exports = __webpack_public_path__ + "static/img/product__bell.d337e5b4.svg";